export default "__VITE_ASSET__BfcBPkgG__"